import React, { useState, useEffect } from "react";
import { Col, Row, Form, Input, Button, Divider, Switch } from "antd";

const RightCol = ({ values, setValues }) => {
  const [totalInputs, setTotalInputs] = useState();

  useEffect(() => {
    setTotalInputs(values.inputs.length);
  }, [values]);

  return (
    <Col>
      <Form
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 15,
        }}
      >
        {/* Copilot Inputs */}
        <h1 className="h2" style={{ marginLeft: "3rem" }}>
          Prompt Inputs
        </h1>

        <Col
          style={{
            overflowY: "scroll",
            height: "calc(55vh - 200px)",
          }}
        >
          {/* For each count in totalInputs render an input contains varName, prompt */}
          {totalInputs > 0 &&
            Array.from(Array(totalInputs).keys()).map((i) => (
              <div key={i}>
                <Form.Item label="Var Name">
                  <Input
                    name="varName"
                    value={values.inputs[i]?.varName}
                    onChange={(e) => {
                      const newInputs = [...values.inputs];
                      newInputs[i].varName = e.target.value;
                      setValues({
                        ...values,
                        inputs: newInputs,
                      });
                    }}
                    placeholder="Ex: backgroundInfo"
                  />
                </Form.Item>

                <Form.Item label="Prompt">
                  <Input
                    name="prompt"
                    value={values.inputs[i]?.prompt}
                    onChange={(e) => {
                      const newInputs = [...values.inputs];
                      newInputs[i].prompt = e.target.value;
                      setValues({
                        ...values,
                        inputs: newInputs,
                      });
                    }}
                    placeholder="Ex: Do you have any background information for Copilotly?"
                  />
                </Form.Item>

                {/* Placeholder */}
                <Form.Item label="Placeholder">
                  <Input
                    name="placeholder"
                    value={values.inputs[i]?.placeholder}
                    onChange={(e) => {
                      const newInputs = [...values.inputs];
                      newInputs[i].placeholder = e.target.value;
                      setValues({
                        ...values,
                        inputs: newInputs,
                      });
                    }}
                    placeholder="Ex: I have worked at Google for 5 years"
                  />
                </Form.Item>
              </div>
            ))}
        </Col>

        <Row
          justify="space-between"
          style={{ paddingLeft: "5rem", paddingRight: "5rem" }}
        >
          {/* Add a button that would  */}
          <Button
            type="primary"
            onClick={() => {
              setTotalInputs(totalInputs + 1);
              setValues({
                ...values,
                inputs: [...values.inputs, { varName: "", prompt: "" }],
              });
            }}
          >
            Add Input
          </Button>

          {/* Remove an input */}
          <Button
            type="danger"
            onClick={() => {
              setTotalInputs(totalInputs - 1);
              setValues({
                ...values,
                inputs: values.inputs.slice(0, -1),
              });
            }}
          >
            Remove Input
          </Button>
        </Row>

        <Divider />

        {/* Publish Copilot */}
        <h1 className="h2" style={{ marginLeft: "3rem" }}>
          Publish Copilot
        </h1>

        <Form.Item label="Publish">
          <Switch
            checked={values.publish}
            onChange={(checked) => {
              setValues({
                ...values,
                publish: checked,
              });
            }}
          />
        </Form.Item>

        {/* Quick Access */}
        <h1 className="h2" style={{ marginLeft: "3rem" }}>
          Quick Access
        </h1>

        <Form.Item label="Quick Access">
          <Switch
            checked={values.quickAccess}
            onChange={(checked) => {
              setValues({
                ...values,
                quickAccess: checked,
              });
            }}
          />
        </Form.Item>
      </Form>
    </Col>
  );
};

export default RightCol;
